<template>
  <div class="steps" :class="`steps--${step}`">
    <div class="steps-circle steps-circle--1">
      <p class="steps-number">STEP.01</p>
      <p class="steps-text">商品を<br />絞り込む</p>
    </div>
    <div class="steps-line" />
    <div class="steps-circle steps-circle--2">
      <p class="steps-number">STEP.02</p>
      <p class="steps-text">商品を<br />選択する</p>
    </div>
    <div class="steps-line" />
    <div class="steps-circle steps-circle--3">
      <p class="steps-number">STEP.03</p>
      <p class="steps-text">商品を<br />一覧で見る</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.steps {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px 0 0;
  @include media() {
    margin: vw(10) 0 vw(45);
  }
  &-line {
    border-top: 1px dashed #df1368;
    width: 38px;
    @include media() {
      width: vw(35);
    }
  }
  &-circle {
    text-align: center;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 50%;
    border: 2px solid #df1368;
    color: #999;
    width: 124px;
    height: 124px;
    @include media() {
      width: vw(94);
      height: vw(94);
    }
    &:before {
      content: "";
      display: none;
      width: 131px;
      height: 142px;
      background: url("../../../assets/images/_parts/other/steps_pc.svg")
        no-repeat center/contain;
      position: absolute;
      top: -2px;
      left: -2px;
      @include media() {
        width: vw(100);
        height: vw(108);
        background-image: url("../../../assets/images/_parts/other/steps_sp.svg");
        top: vw(-2);
        left: vw(-2);
      }
    }
    @for $i from 1 through 3 {
      &--#{$i} {
        .steps--#{$i} & {
          position: relative;
          background: #f8cce0;
          color: #333;
          border-color: transparent;
          &::before {
            display: block;
          }
        }
      }
    }
  }
  &-number {
    font-family: Oswald;
    letter-spacing: 0.1em;
    font-size: 15px;
    font-weight: bold;
    @include media() {
      font-size: vw(12);
    }
  }
  &-text {
    font-size: 13px;
    line-height: (15/11);
    @include media() {
      font-size: vw(11);
    }
  }
}
</style>
